import { render, staticRenderFns } from "./r-attributes.vue?vue&type=template&id=b7e86b54&"
import script from "./r-attributes.vue?vue&type=script&lang=js&"
export * from "./r-attributes.vue?vue&type=script&lang=js&"
import style0 from "./r-attributes.vue?vue&type=style&index=0&id=b7e86b54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports